// Formatting Guideline: https://moment.github.io/luxon/docs/manual/formatting.html
export const getShortDateString = (date: Date): string => {
  return `${date.toLocaleString("default", {
    month: "long",
  })} ${date.getUTCDate()}, ${date.getUTCFullYear()}`;
};
